import Layout from '@layout/Index'

export const fairPrize = [
  {
    path: '/fair_prize',
    component: Layout,
    children: [
      {
        path: 'index',
        component: () => import('./pages/FairPrizeIndex.vue'),
        name: '活动奖品管理',
        meta: {
          title: '活动奖品管理',
        },
      },
      {
        path: 'new',
        component: () => import('./pages/FairPrizeEdit.vue'),
        name: '新增奖品',
        meta: {
          title: '新增奖品',
        },
      },
      {
        path: 'edit/:prizeId',
        component: () => import('./pages/FairPrizeEdit.vue'),
        name: '修改奖品',
        meta: {
          title: '修改奖品',
        },
      },
      {
        path: 'log/index/:id',
        component: () => import('./pages/FairPrizeLogIndex.vue'),
        name: '活动奖品日志',
        meta: {
          title: '活动奖品日志',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/fair-prize/fairPrize.route.js